<template>
    <new-vuestic-modal ref="fotos" v-bind:small="false" :cancelClass="'none'" okClass="none" :closeIconShown="true" :large="true">
        <div slot="title">Fotos</div>
        <div slot="body">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 d-flex flex-row flex-wrap justify-content-center">
                        <img class="p-2" v-for="foto in fotos" :src="'data:image/png;base64, ' + foto.foto" alt="">
                    </div>
                </div>
            </div>
        </div>
    </new-vuestic-modal>
</template>
<script>
export default {
  name: 'ModalFotosAluno',
  props: {
    fotos: Array,
  },
  data () {
    return {

    }
  },
  methods: {
    mostrarFotos () {
      this.$refs.fotos.open('')
    }
  }
}
</script>
